import service from "../libs/request.js";

// 内科 列表
var getNeikeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getNkList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 内科 内容
var getNeikeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getNkInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 外科 列表
var getWaikeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getWkList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 外科 内容
var getWaikeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getWkInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 妇产科 列表
var getFuchankekeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getFckList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 妇产科 内容
var getFuchankeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getFckInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 儿科 列表
var getErkekeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getEkList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 儿科 内容
var getErkeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getEkInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 感染科 列表
var getGanrankeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getGrkList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 感染科 内容
var getGanrankeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getGrkInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 中医科 列表
var getZhongyikeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getZykList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 中医科 内容
var getZhongyikeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getZykInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 五官科 列表
var getWuguankeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getWgkList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 五官科 内容
var getWuguankeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getWgkInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 心理科 列表
var getXinlikeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getXlkList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 心理科 内容
var getXinlikeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getXlkInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 医辅科室 列表
var getYifukeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getYfkList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 医辅科室 内容
var getYifukeArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getYfkInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
//  其它科室 列表
var getQitakeList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getQtkList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 其它科室 内容
var getQitaArticle = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getQtkInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取健康教育-栏目列表
var getChannelList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getChannelList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取健康教育-信息列表
var getChannelInfoList = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getInfoList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取健康教育-信息详情
var getChannelInfo = function(postdata, callback) {
  service.get({
    url: "/wzHealth/getInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

export default {
  getNeikeList,
  getNeikeArticle,
  getWaikeList,
  getWaikeArticle,
  getFuchankekeList,
  getFuchankeArticle,
  getErkekeList,
  getErkeArticle,
  getGanrankeList,
  getGanrankeArticle,
  getZhongyikeList,
  getZhongyikeArticle,
  getWuguankeList,
  getWuguankeArticle,
  getXinlikeList,
  getXinlikeArticle,
  getYifukeList,
  getYifukeArticle,
  getQitakeList,
  getQitaArticle,
  getChannelList,
  getChannelInfoList,
  getChannelInfo,
};
